import React, { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_THEME } from "../contstants";
import { getSubdomain, injectTheme } from "../utils/whitelabel";
import { structuredTheme } from "../utils/helpers";
import { getThemeName } from "../routes/helpers";
import { GetWhiteLabel } from "../api/config/GetWhiteLabel";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const subdomain = getSubdomain(window.location.hostname);
  const THEME_NAME = getThemeName();
  const [appTheme, setTheme] = useState(null);

  const { theme } = appTheme || {};

  const saveTheme = (theme) => {
    localStorage.setItem(THEME_NAME, JSON.stringify(theme));
  };

  // update css variables from theme
  useEffect(() => {
    if (theme) {
      const root = document.querySelector(":root");
      root.style.setProperty("--btn-primary-background", theme.primary);
      root.style.setProperty(
        "--btn-primary-hover-background",
        theme.primary_dark
      );
      root.style.setProperty(
        "--layout-left-background-color",
        theme.header_background
      );
      root.style.setProperty("--sidebar-link-color", theme.header_text);
      root.style.setProperty("--body-background-color", theme.background);

      // update favicon
      const favicon = document.querySelector("link[rel='icon']");
      if (favicon) {
        favicon.href = theme.favicon;
      }

      // update title
      document.title =
        theme.copyright_company_name || "Pay Hub Portal - Berkeley";
    }
    // eslint-disable-next-line
  }, [theme]);

  useEffect(() => {
    const localtheme = localStorage.getItem(THEME_NAME)
      ? JSON.parse(localStorage.getItem(THEME_NAME))
      : null;
    // fetch whitelabel api
    const fetchWhitelabel = async () => {
      let themeData = injectTheme(structuredTheme(DEFAULT_THEME));
      try {
        const response = await GetWhiteLabel(subdomain);
        themeData = injectTheme(structuredTheme(response.data));
        saveTheme(response.data);
      } catch (error) {
        console.error("Error fetching whitelabel:", error);
      } finally {
        setTheme(themeData);
      }
    };
    if (localtheme) {
      const themeData = injectTheme(structuredTheme(localtheme));
      setTheme(themeData);
    }
    fetchWhitelabel();

    // eslint-disable-next-line
  }, []);
  return (
    <ThemeContext.Provider
      value={{
        ...appTheme,
        setTheme,
        subdomain,
      }}
    >
      {appTheme ? (
        <>{children}</>
      ) : (
        <div className="fixingup">Fixing things up for you...</div>
      )}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};
